module.exports = __webpack_public_path__ + "static/media/ic_message_circle.a3e624d0.svg";